import { pluralizeToString } from '~/utils/stringUtils';

/** "12 changes", or "Newest 100 of 240 changes" when only the newest rows are shown. */
export function newestOfCountLabel(noun: string, shownCount: number, totalCount: number) {
  const countLabel = pluralizeToString(noun, totalCount);
  return totalCount > shownCount ? `Newest ${shownCount} of ${countLabel}` : countLabel;
}
